import { inject, Injectable } from '@angular/core';
import { UseCase } from '@shared/helper';
import { GetPackageDetailDto, GetPackageDetailResp } from './get-package-detail.type';
import { PackageRepository } from '@data/repositories/package.repository';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class GetPackageDetailUsecase implements UseCase<GetPackageDetailDto, GetPackageDetailResp> {
    packageRepository = inject(PackageRepository);

    execute(params: GetPackageDetailDto): Observable<GetPackageDetailResp> {
        return this.packageRepository.GetPackageDetail(params);
    }
}